
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@ember/jquery/-embroider-implicit-modules.js";
import "ember-classic-decorator/-embroider-implicit-modules.js";
import "ember-decorators/-embroider-implicit-modules.js";
import "@square/dashboard-translations/-embroider-implicit-modules.js";
import "@square/phone-number/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/ember-features/-embroider-implicit-modules.js";
